import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'

import AppInit from './app-init'

import MainLayout from './main-layout'

export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
            refetchIntervalInBackground: true,
        },
    },
})

const App = () => {
    return (
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <AppInit>
                    <MainLayout />
                </AppInit>
            </BrowserRouter>
        </QueryClientProvider>
    )
}

export default App
